import React from "react";
import OrderPayment from "../../components/User/OrderPayment";

export default function UserOrderPaymentPage() {
  return <OrderPayment />;
}